/* eslint-disable no-unused-vars */
import { isNullOrEmptyArray } from '@/helpers/array-helpers'
import VuetifyColourClass from '@/constants/core/VuetifyColourClass'
import PromiseDialogActionsDto from './promiseDialogActionsDto'

/**
 * @class
 * @public
 */
export default class PromiseDialogDto {
  /**
   * @constructor
   */
  constructor({
    title = '',
    text = '',
    actions = [],
    color = VuetifyColourClass.primary,
    icon,
    persistent = false,
  } = {}) {
    /**
     * Dialog title text
     * @type {String}
     */
    this.title = title

    /**
     * Description text displayed under the title
     * @type {String}
     */
    this.text = text

    /**
     * List of objects that configure the action buttons on the dialog.
     * Each object will generate a button. Actions will be generated in LIFO
     * order.
     * @type {Array<PromiseDialogActionsDto>}
     */
    this.actions = isNullOrEmptyArray(actions)
      ? []
      : actions.map((action) => new PromiseDialogActionsDto(action))

    /**
     * Vuetify color class that will style the icon
     * @type {String}
     * @see {VuetifyColourClass} for valid range of values.
     */
    this.color = color

    /**
     * Icon displayed above the title, center aligned. MDI icon string.
     * @type {String}
     * @see https://pictogrammers.com/library/mdi for valid range of values.  Needs to be prefixed with `mdi-`
     */
    this.icon = icon

    /**
     * Disables being able to close the dialog by clicking outside the dialog
     * card
     * @type {Boolean}
     */
    this.persistent = persistent
  }
}
